export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'zhuanzhu-zhidao',
    name: '专注之道',
    description: '探索专注力的本源，学习如何在纷扰世界中守住内心的一方净土，以专一之心成就非凡之事。',
    icon: 'ri-focus-2-line',
    articleCount: 8,
  },
  {
    slug: 'mubiao-guanli',
    name: '目标管理',
    description: '从设定到执行，从坚持到突破，系统化掌握目标管理的核心方法论，让每一步都走得更稳。',
    icon: 'ri-flag-2-line',
    articleCount: 10,
  },
  {
    slug: 'rensheng-zhexue',
    name: '人生哲学',
    description: '汲取古今智慧，融汇东西方思想精华，构建属于自己的人生哲学体系，活出通透与从容。',
    icon: 'ri-lightbulb-line',
    articleCount: 7,
  },
  {
    slug: 'xinlu-licheng',
    name: '心路历程',
    description: '真实的人生故事与成长感悟，在他人经历中照见自己，在共鸣中获得前行的力量与勇气。',
    icon: 'ri-heart-line',
    articleCount: 9,
  },
];